import { TaskService } from 'data/services';
import { TaskServiceInterface } from 'domain/services';
import { makeRemoteTaskCreate } from 'main/factories/usecases/Task/task-create-factory';
import { makeRemoteTaskDelete } from 'main/factories/usecases/Task/task-delete-factory';
import { makeRemoteTaskGetById } from 'main/factories/usecases/Task/task-get-by-id-factory';
import { makeRemoteTaskList } from 'main/factories/usecases/Task/task-list-factory';
import { makeRemoteTaskUpdate } from 'main/factories/usecases/Task/task-update-factory';

export const makeTaskService = (): TaskServiceInterface => {
  return new TaskService({
    taskList: makeRemoteTaskList(),
    taskCreate: makeRemoteTaskCreate(),
    taskUpdate: makeRemoteTaskUpdate(),
    taskDelete: makeRemoteTaskDelete(),
    taskGetById: makeRemoteTaskGetById(),
  });
};
